import React from 'react';
import Button from '@mui/material/Button';

type Props = {
    disabled?: boolean;
    isLoading?: boolean;
    text: string;
    onClick: () => void;
};

const MuiButton = (props: Props) => {
    const { disabled, isLoading, text, onClick } = props;
    return (
        <Button
            onClick={onClick}
            disabled={disabled || isLoading}
            loading={isLoading}
            sx={{
                width: '100%',
                ':disabled': { backgroundColor: '#D1D5DB', color: '#F8F8F8' },
                padding: '13px',
                fontSize: '15px',
                fontWeight: 600,
                color: '#ffffff',
                backgroundColor: '#000000',
                borderRadius: '8px',
                textTransform: 'none',
            }}
            variant="contained">
            {text}
        </Button>
    );
};

export default MuiButton;
